import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Re-renders the current page every few seconds while something it shows is still being
// worked on in the background (e.g. a bulk access grant being previewed or run). The
// server stops rendering this controller once the work is done, which ends the polling.
export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 } };

  connect() {
    this.timer = setTimeout(() => {
      Turbo.visit(window.location.href, { action: "replace" });
    }, this.intervalValue);
  }

  disconnect() {
    clearTimeout(this.timer);
  }
}
